module.exports = __webpack_public_path__ + "static/img/09-gdwz.f1e3b72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter/09-gdwz.png
// module id = 3/DQ
// module chunks = 1